import React, { ReactNode } from 'react'
import { Typography } from 'foundations-library/components'

interface HeadingProps {
    children: ReactNode
}

/**
 * Custom blue-ish, left aligned headings that are unique to signup
 */
const Heading = (props: HeadingProps) => {
    return (
        <Typography variant="h7" align="left" {...props}>
            {props.children}
        </Typography>
    )
}

export default Heading
